import { orderBy } from "lodash";
import {
  OrgSelfIdQuestionOptionNode,
  PublicOrgSelfIdQuestionOptionNode,
} from "../../modules/graphql.types";

type Option = OrgSelfIdQuestionOptionNode | PublicOrgSelfIdQuestionOptionNode;

export const sortSelfIdQuestionAnswers = <T extends Option>(answers: T[]) => {
  const alphaSorted = orderBy(
    answers ?? [],
    (a) => a?.name?.toLocaleUpperCase(),
    "asc"
  );

  // sort with the prefer not to answer option at the end
  return orderBy(
    alphaSorted,
    (a) => {
      if (a.name === "Prefer not to answer") {
        return -1;
      }
      return 1;
    },
    "desc"
  );
};
